/* eslint-disable */
export const contacts = [
    {
        id: 'cd5fa417-b667-482d-b208-798d9da3213c',
        avatar: 'images/avatars/nela.png',
        background: '',
        name: 'Mrózková Nella',
        emails: [
            {
                email: 'mrozkova.nella@mail.com',
                label: 'Personal',
            },
            {
                email: 'mrozkova.nella@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '984 531 2468',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '806 470 2693',
                label: 'Work',
            },
        ],
        title: 'Stylistka',
        company: '',
        birthday: '1975-01-10T12:00:00.000Z',
        address: '279 Independence Avenue, Calvary, Guam, PO4127',
        notes: '',
        tags: ['c31e9e5d-e0cb-4574-a13f-8a6ee5ff8309'],
    },
    {
        id: 'beec5287-ed50-4504-858a-5dc3f8ce6935',
        avatar: 'images/avatars/gabriela.png',
        background: null,
        name: 'Czyžová Gabriela',
        emails: [
            {
                email: 'czyzova.gab@gmail.com',
                label: 'Personal',
            },
            {
                email: 'zcyzova.gabriela@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '934 537 3180',
                label: 'Mobile',
            },
        ],
        title: 'Education manager',
        company: 'Envire',
        birthday: '1994-12-05T12:00:00.000Z',
        address: '856 Woodside Avenue, Alfarata, Iowa, PO4992',
        notes: '',
        tags: ['56ddbd47-4078-4ddd-8448-73c5e88d5f59'],
    },
    {
        id: '9d3f0e7f-dcbd-4e56-a5e8-87b8154e9edf',
        avatar: 'images/avatars/natalie.png',
        background: '',
        name: 'Witová Natálie',
        emails: [
            {
                email: 'natalie.wita@mail.com',
                label: 'Personal',
            },
            {
                email: 'natalie.witova@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '893 548 2862',
                label: 'Mobile',
            },
        ],
        title: 'Director',
        company: 'Boilcat',
        birthday: '1988-05-26T12:00:00.000Z',
        address: '943 Adler Place, Hamilton, South Dakota, PO5592',
        notes: '',
        tags: ['c31e9e5d-e0cb-4574-a13f-8a6ee5ff8309'],
    },
    {
        id: '42a5da95-5e6d-42fd-a09d-de755d123a47',
        avatar: 'images/avatars/vanessa.png',
        background: '',
        name: 'Witová Vanessa',
        emails: [
            {
                email: 'vanessa.witova@gmail.com',
                label: 'Personal',
            },
            {
                email: 'vanessa.witova@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '830 484 3813',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '999 475 2789',
                label: 'Work',
            },
            {
                country: 'cz',
                phoneNumber: '933 406 3598',
                label: 'Home',
            },
        ],
        title: 'Stylist',
        birthday: '1968-08-13T12:00:00.000Z',
        address: '334 Sandford Street, Savage, Virgin Islands, PO1858',
        notes: '',
        tags: ['56ddbd47-4078-4ddd-8448-73c5e88d5f59'],
    },
    {
        id: 'a7806ced-03f1-4197-8b30-00bdd463366b',
        avatar: 'images/avatars/nikola.png',
        background: '',
        name: 'Salavová Nikol',
        emails: [
            {
                email: 'nikola.salavova@seznam.cz',
                label: 'Personal',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '864 401 3980',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '956 546 2589',
                label: 'Work',
            },
        ],
        title: 'Stylist',
        company: '',
        birthday: '1983-12-22T12:00:00.000Z',
        address: '487 Hamilton Walk, Bergoo, American Samoa, PO5616',
        notes: '',
        tags: ['2026ce08-d08f-4b4f-9506-b10cdb5b104f'],
    },
    {
        id: 'f4ad15d9-5a24-463a-88ea-6189d6bb3a53',
        avatar: 'images/avatars/pavla.png',
        background: '',
        name: 'Chmielová Pavla',
        emails: [
            {
                email: 'chmielova@gmail.com',
                label: 'Personal',
            },
            {
                email: 'pavla.chmielova@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '834 426 3574',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '816 573 3694',
                label: 'Work',
            },
            {
                country: 'cz',
                phoneNumber: '967 515 2009',
                label: 'Home',
            },
        ],
        title: 'Kosmetička',
        company: '',
        birthday: '1963-08-24T12:00:00.000Z',
        address: '610 Harbor Lane, Cascades, Minnesota, PO8639',
        notes: '',
        tags: ['c31e9e5d-e0cb-4574-a13f-8a6ee5ff8309'],
    },
    {
        id: '780d0111-5e5c-4694-8d1d-0ea421971fbf',
        avatar: 'images/avatars/kristyna.png',
        background: '',
        name: 'Dudková Kristýna',
        emails: [
            {
                email: 'kristyna.dudkova@gmail.com',
                label: 'Personal',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '964 417 2318',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '830 410 2506',
                label: 'Work',
            },
        ],
        title: 'Stylist',
        company: '',
        birthday: '1973-09-25T12:00:00.000Z',
        address: '428 Newport Street, Neahkahnie, Arkansas, PO8324',
        notes: '',
        tags: ['a8991c76-2fda-4bbd-a718-df13d6478847'],
    },
    {
        id: 'bf172879-423a-4fd6-8df3-6d1938bbfe1f',
        avatar: 'images/avatars/magdalena.png',
        background: '',
        name: 'Kozlová Magdaléna',
        emails: [
            {
                email: 'magdalena.kozlova@gmail.com',
                label: 'Personal',
            },
            {
                email: 'magdalena.kozlova@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '934 519 2903',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '989 489 3662',
                label: 'Work',
            },
            {
                country: 'cz',
                phoneNumber: '813 461 2790',
                label: 'Home',
            },
        ],
        title: 'Stylist',
        company: '',
        birthday: '1988-07-27T12:00:00.000Z',
        address: '384 Polhemus Place, Dalton, Palau, PO6038',
        notes: '',
        tags: ['3eaab175-ec0d-4db7-bc3b-efc633c769be'],
    },
    {
        id: 'bf172879-423a-4fd6-8df3-6d1938bbfe1g',
        avatar: 'images/avatars/natasa.png',
        background: '',
        name: 'Huzenko Nataša',
        emails: [
            {
                email: 'natasa.huzenko@gmail.com',
                label: 'Personal',
            },
            {
                email: 'huzenko.natasa@witova.cz',
                label: 'Work',
            },
        ],
        phoneNumbers: [
            {
                country: 'cz',
                phoneNumber: '934 519 2903',
                label: 'Mobile',
            },
            {
                country: 'cz',
                phoneNumber: '989 489 3662',
                label: 'Work',
            },
            {
                country: 'cz',
                phoneNumber: '813 461 2790',
                label: 'Home',
            },
        ],
        title: 'Stylist',
        company: '',
        birthday: '1988-07-27T12:00:00.000Z',
        address: '384 Polhemus Place, Dalton, Palau, PO6038',
        notes: '',
        tags: ['3eaab175-ec0d-4db7-bc3b-efc633c769be'],
    }
];

export const tags = [
    {
        id: 'c31e9e5d-e0cb-4574-a13f-8a6ee5ff8309',
        title: 'Dámské stříhání',
    },
    {
        id: 'a8991c76-2fda-4bbd-a718-df13d6478847',
        title: 'Pánské stříhání',
    },
    {
        id: '56ddbd47-4078-4ddd-8448-73c5e88d5f59',
        title: 'Foukání',
    },
    {
        id: '2026ce08-d08f-4b4f-9506-b10cdb5b104f',
        title: 'Barvení',
    }
];
